<div class="d-flex gap-3 dashboard-header">
	@if (is_new_vat_number) {
		<app-gen-select
			[actualObj]="this"
			fieldName="vat_number"
			[options]="vat_numbers"
			(changeEvent)="getData()"
			class="pad-btns"
		/>
	}
	<app-gen-button-group
		[actualObj]="this"
		fieldName="freq"
		optionsListName="graphs_freqs"
		(changeEvent)="freqChange(); getData()"
		class="pad-btns"
	/>
	@if (freq == "yearly") {
			<div class="d-flex gap-2" style="width: 152px;">
				<div>
					<label>{{ "year_from" | langVal }}</label>
					<app-gen-select
						[options]="years"
						[actualObj]="this"
						fieldName="yearFrom"
						(changeEvent)="getData()"
					/>
				</div>
				<div>
					<label>{{ "year_to" | langVal }}</label>
					<app-gen-select
						[options]="years"
						[actualObj]="this"
						fieldName="yearTo"
						(changeEvent)="getData()"
					/>
				</div>
			</div>
	} @else {
		<app-gen-button-group
			[actualObj]="this"
			fieldName="timeRange"
			optionsListName="graphs_time_ranges"
			(changeEvent)="getData()"
			class="pad-btns"
			style="width: 152px;"
		/>
	}
</div>

<div class="dashboard">
	<div class="container">
		<div class="title">
			<h2>
			{{ "debts" | langVal }}
				<button
				class="btn btn-icon"
				titleLang="report_defs"
				[icon]="'leftArrow'"
				style="min-height: 20px"
				></button>
			</h2>
				<button
				class="btn btn-icon"
				titleLang="debts"
				[icon]="'settings2'"
				style="min-height: 20px"
				></button>
		</div>
		<div class="content">
			<div class="dash-table">
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
			</div>
		</div>
	</div>
	<div class="container">
		<div class="title">
			<h2>
			{{ "debts" | langVal }}
				<button
				class="btn btn-icon"
				titleLang="report_defs"
				[icon]="'leftArrow'"
				style="min-height: 20px"
				></button>
			</h2>
				<button
				class="btn btn-icon"
				titleLang="debts"
				[icon]="'settings2'"
				style="min-height: 20px"
				></button>
		</div>
		<div class="content">
			<div class="dash-table">
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
			</div>
		</div>
	</div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
</div>

<div class="dashboard d-grid delete">
	<app-spin-or-content [isSpin]="isLoading">
		@for (outputGraph of outputGraphs; track outputGraph) {
			<div class="container">
				<div class="title">
					<h2>{{ outputGraph.lang | langVal }}</h2>
					<div class="d-flex gap-2">
						@for (field of fields[outputGraph.name] | keyvalue; track field.key) {
							<input
								type="checkbox"
								[checked]="fields[outputGraph.name][field.key]"
								(change)="
									fields[outputGraph.name][field.key] = $event.target.checked;
									renderData()
								"
							/>
							{{ field.key | langVal }}
						}
					</div>
				</div>
				<!-- <div style="direction: ltr; height: 500px"> -->
				@if (!isLoading) {
					<ngx-charts-bar-horizontal-2d
						[view]="view"
						[scheme]="colorScheme"
						[results]="data[outputGraph.name]"
						[gradient]="true"
						[xAxis]="true"
						[yAxis]="true"
						[legend]="false"
						[showXAxisLabel]="true"
						[showYAxisLabel]="true"
						[xAxisLabel]="freq | langVal"
						[yAxisLabel]="outputGraph.lang | langVal"
						[legendTitle]="'columns' | langVal"
						(select)="onSelect($event)"
						(activate)="onActivate($event)"
						(deactivate)="onDeactivate($event)"
					>
					</ngx-charts-bar-horizontal-2d>
				}
				<!-- </div> -->
			</div>
		}
	</app-spin-or-content>
</div>
